import React, { useEffect, useRef, useState, useCallback } from "react";
import { ReactComponent as ListIcon } from "../../Assets/Icons/ListIcon.svg";
import { ReactComponent as MapIcon } from "../../Assets/Icons/MapIcon.svg";
import { ReactComponent as AscendingDescendingSortIcon } from "../../Assets/Icons/AscendingDescendingSortIcon.svg";
import { ReactComponent as DownloadDownIcon } from "../../Assets/Icons/DownloadDownIcon.svg";
import { ReactComponent as SliderIcon } from "../../Assets/Icons/SliderIcon.svg";
import { table } from "../../Assets/MockData/index.js";
import {
  Count,
  GraphSection,
  MainContainer,
  Reset,
  Slider,
  SliderContentFirst,
  SliderContentSecond,
  SliderHoverContainer,
  Title,
  TitleBlock,
  TitleSection,
  TopSection,
  ViewContainer,
  Wrapper,
  MainContent,
  TopSectionContent,
} from "./index.styled";
import { HexbinMainContainer } from "../../graph/graphs/HexbinGraph/Hexagon/hexagon.styled";
import Hexagon from "../../graph/graphs/HexbinGraph/Hexagon";
import { updatedMarketData } from "../../graph/graphs/HexbinGraph/Hexagon/data";
import { exportOptions, views } from "../../Configs/config";
import {
  getCountByState,
  getHospitalsByUrl,
} from "../../services/apiService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CustomTable from "../CustomTable";
import { FilterBox } from "../RightSection/index.styled.js";
import {
  clearProviderNumbers,
  setGlobalSearchReset,
  setHospitalsDetails,
  setIsBookmarkTable,
  setTableResetting,
} from "../../Redux/app/app.actions.js";
import {
  resetSelectedState,
  resetSpecificStateData,
} from "../../Redux/hospital/hospital.actions";
import { useFilters } from "../../hooks/useFilters.js";
import { useResolvedStates } from "../../hooks/useResolvedStates.js";
import { addHospitalToCompare } from "../../Redux/compare/compare.actions";
import { useDispatch, useSelector } from "react-redux";
import ResetModal from "../ResetModal/index.jsx";
import { BackgroundOverlay } from "../FilterComp/index.styled.js";
import { TextSkeleton } from "../Skeletons/index.styled.js";
import TableSkeleton from "../Skeletons/Variants/TableSkeleton.jsx";
import OptionsList from "../OptionsList";
import Info from "../Info/index.jsx";
import {
  Span,
  SubTitle,
  SubTitleBold,
} from "../HospitalList/HospitalListCard.styled.js";
import {
  exportTableData,
  formatHospitalDetails,
  toTitleCase,
  viewSizeCalculator,
} from "../../utils/index.js";
import { buildHospitalsUrl as buildHospitalsUrlPure } from "../../utils/buildHospitalsUrl.js";
import { generateTableTitle } from "../../utils/generateTableTitle";
import { useSnack } from "../SnackBar";
import Loading from "../CustomTable/Loader/index.jsx";
import {
  ColorGradient,
  ColorScaleLegend,
  LegendLabel,
  LoadMoreContainer,
} from "../CustomTable/index.styled.js";

const LeftSection = ({
  view,
  filterFlag,
  // isGraphCellClicked,
  data,
  showSkelton,
  setShowSkelton,
  selectedOption,
  setSelectedOption,
  setGlobalCustomFilterOption,
  // fetchTableViewData, // REMOVED - no longer needed
  toggleState,
  resetFlag,
  setResetFlag,
  totalHospitals,
  setTotalHospitals,
  setFilteredData,
}) => {
  // Refs
  const { compareHospitals } = useSelector((state) => state.compare);
  const parentRef = useRef(null);
  const graphAreaRef = useRef(null);
  const [mapAreaReady, setMapAreaReady] = useState(false);

  const setGraphAreaRef = useCallback((node) => {
    graphAreaRef.current = node;
    setMapAreaReady(!!node);
  }, []);
  const exportDropdownRef = useRef(null);
  const sortModelDropdownRef = useRef(null);
  const [isExportDropdownOpen, setIsExportDropdownOpen] = useState(false);
  const [preventToggle, setPreventToggle] = useState(false);
  const [showBulkCount, setShowBulkCount] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [removeIds, setRemoveIds] = useState([]);
  const [isCompareActive, setIsCompareActive] = useState(true);

  // Lazy loading state - Single source of truth
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [currentFilters, setCurrentFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [displayedRange, setDisplayedRange] = useState({ start: 1, end: 50 });
  const observerRef = useRef();
  // const [isCompareHovered, setIsCompareHovered] = useState(false);

  // const handleBulkAddToCompare = () => {
  //   if (!selectedIds.length && !removeIds.length) return;

  //   const idToRowMap = new Map(data.map(row => [row.provider_number, row]));
  //   const MAX_COMPARE_COUNT = 20;

  //   if (removeIds.length) {
  //     dispatch(removeHospitalFromCompare(removeIds));
  //   }

  //   const newCompareCount = compareHospitals.length - removeIds.length;
  //   const remainingSpace = MAX_COMPARE_COUNT - newCompareCount;

  //   if (remainingSpace <= 0 && selectedIds.length ) {
  //     setMaxSnackbarCount(true);
  //     return;
  //   };

  //   const payloads = selectedIds.slice(0, remainingSpace).map(id => {
  //     const data = idToRowMap.get(id);
  //     if (!data) return null;
  //     return {
  //       value: data["hospital name"],
  //       label: toTitleCase(data["hospital name"]),
  //       location: data["location"],
  //       provider_number: data.provider_number,
  //     };
  //   }).filter(Boolean);

  //   if (payloads.length) {
  //     dispatch(addHospitalToCompare(payloads));
  //     setShowBulkCount(true);
  //   }

  //   // setIsCompareActive(false);
  //   setIsCompareHovered(false);
  //   setRemoveIds([]);
  // };

  const onPreventToggle = (flag) => {
    setPreventToggle(flag);
  };

  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  // Export always pulls the full current dataset from the /export endpoint, so
  // a mutation keeps it out of the read cache.
  const exportMutation = useMutation({
    mutationFn: (exportUrl) => getHospitalsByUrl(exportUrl),
  });
  const snack = useSnack();
  const {
    tableViewData,
    isGlobalSearchReset,
    isBookmarkTable,
    dataRefetchTrigger,
    isTableResetting,
    countByProvidernumber,
  } = useSelector((store) => store.app);
  const {
    partnerExclusiveFlag,
    globalFilter,
    quickFilter,
    legendFilter,
    search,
    filters: appliedAdvancedFilters,
    clearMapSelection,
    updateSearchParams,
    resetFilters,
  } = useFilters();
  // Human-friendly title for an active search, derived from the URL `q` param so
  // it survives a refresh / shared link (no longer sourced from the retired
  // Redux isSearchData/tableTitle flags).
  const searchTitle = search
    ? `Search Results : ${toTitleCase(search)}`
    : null;
  // Advanced filters live in the URL. On a refresh the redux filterFlag resets
  // to false before FilterComp re-applies them, so use this to defer the
  // all-hospitals fetch until the URL filters have been restored.
  const hasUrlAdvancedFilters =
    Object.keys(appliedAdvancedFilters || {}).length > 0;
  // A legend filter no longer persists its states in the URL, so derive the
  // active selection (explicit `states` param OR legend-derived) here. Used for
  // table fetch routing, headers and the export URL.
  const { effectiveStates: states, legendPending } = useResolvedStates();
  // Human-friendly title for an active advanced-filter set, derived straight
  // from the URL params (same as searchTitle) so it survives a refresh / shared
  // link independent of FilterComp's dispatch timing. Applying advanced filters
  // clears the legend/state selection, so `states` here is just the URL `state`
  // param (when the filter set includes a state).
  const advancedFilterTitle =
    hasUrlAdvancedFilters && view === views.TABLE
      ? `Search Results : ${generateTableTitle({
          ...appliedAdvancedFilters,
          state: states?.[0] || "",
        })}`
      : null;
  const { selectedStateData, specificStateData } = useSelector(
    (store) => store.hospital,
  );
  // Single source for the header title: an active search or advanced-filter set
  // (both URL-derived, refresh-safe) takes precedence. A bookmark table derives
  // its title from the durable `isBookmarkData` flag rather than the mutable
  // `tableTitle` string — the latter can get transiently cleared by the fetch
  // reset when arriving from the map (filterFlag not yet reflecting the bookmark
  // context), which would otherwise fall back to the "All States" table title.
  const resolvedTableTitle =
    searchTitle ||
    advancedFilterTitle ||
    (view === views.TABLE && tableViewData?.isBookmarkData
      ? "All Bookmarks"
      : "") ||
    tableViewData?.tableTitle ||
    "";

  // State management
  const [showLoader, setShowLoader] = useState(true);
  const [showResetModal, setShowResetModal] = useState(false);
  // const [resetFlag, setResetFlag] = useState(false);

  // Hexbin map state
  const [updatedData, setUpdatedData] = useState(
    JSON.parse(JSON.stringify(updatedMarketData)),
  );
  // const [totalHospitals, setTotalHospitals] = useState(0);
  const [density, setDensity] = useState({ low: 0, medium: 0, high: 0 });
  const [densityHospitalCount, setDensityHospitalCount] = useState({
    low: 0,
    medium: 0,
    high: 0,
  });
  const [parentWidth, setParentWidth] = useState(0);
  const [labelFontSize, setLabelFontSize] = useState(0);
  const [isClicked, setIsClicked] = useState({
    row: null,
    column: null,
    value: false,
    data: null,
  });

  // Table view state
  const [localSelectedOption, setLocalSelectedOption] = useState(
    selectedOption || "RANKING",
  );
  const [sortingLabel, setSortingLabel] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isSortingDisabled, setIsSortingDisabled] = useState(true);
  const [isExportHovered, setIsExportHovered] = useState(false);
  const [isMapHovered, setIsMapHovered] = useState(false);
  const [isTableHovered, setIsTableHovered] = useState(false);
  const [isSortModelOpen, setIsSortModelOpen] = useState(false);
  const [isSortModelHovered, setIsSortModelHovered] = useState(false);

  // Derive a stable filter flag to avoid undefined-induced resets and treat actual state-selection as a filter context
  const isStateContextActive =
    (states && Array.isArray(states) && states.length > 0) ||
    (specificStateData && specificStateData.abbreviation);

  // Build a human-friendly title from the applied global filter so the map/table
  // headers reflect the active filter (e.g. "CoC Accrediated Hospitals") instead
  // of the misleading default. Returns null when no filter ("all") is applied.
  const globalFilterTitle = (() => {
    const label = globalFilter?.label?.trim();
    if (!label || globalFilter?.value === "all") return null;
    return /hospitals?$/i.test(label) ? label : `${label} Hospitals`;
  })();

  // Check if data already exists in Redux state when component mounts or view changes
  useEffect(() => {
    if (view === views.TABLE && tableViewData?.data !== undefined) {
      // Hide loader if data exists (even if empty) or if we're in table view
      setShowLoader(false);
    }
    if (tableViewData?.data.length <= 50) {
      setPage(1);
      setDisplayedRange({ start: 1, end: tableViewData?.data.length });
    }
    // Safety net: once real rows arrive, ensure the reset-in-progress flag is
    // cleared even if the re-fetch's finally block was skipped (e.g. an
    // in-flight request short-circuited fetchHospitalData).
    if (isTableResetting && tableViewData?.data?.length > 0) {
      dispatch(setTableResetting(false));
    }
  }, [view, tableViewData?.data]);

  const fetchStatesData = async () => {
    setShowLoader(true);
    try {
      // Shared count_by_state cache (same key as useResolvedStates), so the map
      // paint and the legend resolver reuse a single fetch.
      const apiData = await queryClient.fetchQuery({
        queryKey: [
          "count-by-state",
          {
            partnerExclusiveFlag,
            globalFilter: globalFilter?.value,
            quickFilter,
          },
        ],
        queryFn: ({ signal }) =>
          getCountByState(
            {
              partnerExclusiveFlag,
              globalFilter: globalFilter?.value,
              quickFilter,
            },
            signal,
          ),
        staleTime: 5 * 60 * 1000,
      });
      setShowSkelton(true);
      const hospitalCountMap = new Map(
        apiData.data.map((item) => [item.state, item.hospital_count]),
      );
      const caseDensityMap = new Map(
        apiData.data.map((item) => [item.state, item.case_density]),
      );
      const partnerMap = new Map(
        apiData.data.map((item) => [item.state, !!item.has_partner]),
      );
      const temp = JSON.parse(JSON.stringify(updatedData));
      let count = 0;
      let low = 0,
        medium = 0,
        high = 0;

      let tempLow = 0,
        tempMedium = 0,
        tempHigh = 0,
        tempPartner = 0;

      temp.data.forEach((item) => {
        const hospitalCount = hospitalCountMap.get(item.abbrev) || 0;
        const caseDensity =
          Number(Math.round(caseDensityMap.get(item.abbrev))) || 0;
        count += hospitalCount;
        // Assign hospital count
        item.value = hospitalCount;
        item.case_density = caseDensity;
        // Flag partner (ESA) locations so the hexagon renders a notch
        item.isPartner = partnerMap.get(item.abbrev) || false;
        if (item.isPartner) tempPartner += hospitalCount;
        // Determine performance category
        if (legendFilter === null) {
          if (caseDensity > 470) {
            item.performance = "high";
            high = high + caseDensity;
            item["border"] = "#B73218";
          } else if (caseDensity > 400) {
            item.performance = "medium";
            medium = medium + caseDensity;
            item["border"] = "#E56147";
          } else {
            item.performance = "low";
            item["border"] = "#FFC5BA";
            low = low + caseDensity;
          }
        } else {
          if (caseDensity > 470) {
            item.performance = "high";
            tempHigh = tempHigh + hospitalCount;
            item["border"] = "#B73218";
          } else if (caseDensity > 400) {
            item.performance = "medium";
            tempMedium = tempMedium + hospitalCount;
            item["border"] = "#E56147";
          } else {
            item.performance = "low";
            item["border"] = "#FFC5BA";
            tempLow = tempLow + hospitalCount;
          }
        }
      });
      setDensity({ low, medium, high });
      setDensityHospitalCount({
        low: tempLow,
        medium: tempMedium,
        high: tempHigh,
        partner: tempPartner,
      });
      // setTotalHospitals(count); // REMOVED - totalHospitals managed by HomePage
      setUpdatedData(temp);
    } catch (error) {
      // Error handling for hospital count fetch
    } finally {
      setShowLoader(false);
      setShowSkelton(false);
    }
  };

  useEffect(() => {
    if (view === views?.MAP) {
      fetchStatesData();
      resetSortAndFilters();
    }
  }, [view, partnerExclusiveFlag, globalFilter, quickFilter]);

  // The map view never shows a "Search Results" title or search-scoped card
  // counts. When we land on the map without an active search (e.g. after the
  // reset modal clears the `q` param), drop any lingering search title and
  // provider-number counts so the header and quick-filter cards reflect the
  // map's all-hospitals context. Keyed on tableTitle/provider numbers too so it
  // also catches a late-resolving search fetch that dispatched after the reset.
  useEffect(() => {
    if (view !== views.MAP || search) return;
    // A bookmark "View in Table" click sets the table context (title +
    // provider-number counts) and flips the URL to table view in separate
    // steps. `view` is derived from the URL, so there's a transient render
    // where it still reads `map` while the just-dispatched "All Bookmarks"
    // title is already in Redux. Skip the map cleanup in that window so we
    // don't clobber the bookmark title/counts (which would fall back to the
    // "All States" table title once the URL catches up).
    if (tableViewData?.isBookmarkData) return;
    if (tableViewData?.tableTitle) {
      dispatch(setHospitalsDetails({ tableTitle: "" }));
    }
    if (countByProvidernumber?.length) {
      dispatch(clearProviderNumbers());
    }
  }, [
    view,
    search,
    tableViewData?.tableTitle,
    tableViewData?.isBookmarkData,
    countByProvidernumber,
    dispatch,
  ]);

  // TEMPORARY FIX — remove once React Query is implemented.
  // With React Query the count_by_state data would be cached and survive route
  // changes (e.g. navigating to a factsheet and back), so this manual refetch
  // would be unnecessary.
  //
  // Lightweight fetch that only recomputes the per-bucket hospital counts used
  // by the legend-filter title. Needed in TABLE view because the map-derived
  // `densityHospitalCount` is local state that is lost when LeftSection
  // remounts (e.g. returning from a hospital factsheet), and the map fetch
  // does not run in table view.
  const fetchLegendDensityCounts = async () => {
    try {
      const apiData = await queryClient.fetchQuery({
        queryKey: [
          "count-by-state",
          {
            partnerExclusiveFlag,
            globalFilter: globalFilter?.value,
            quickFilter,
          },
        ],
        queryFn: ({ signal }) =>
          getCountByState(
            {
              partnerExclusiveFlag,
              globalFilter: globalFilter?.value,
              quickFilter,
            },
            signal,
          ),
        staleTime: 5 * 60 * 1000,
      });
      const hospitalCountMap = new Map(
        apiData.data.map((item) => [item.state, item.hospital_count]),
      );
      const caseDensityMap = new Map(
        apiData.data.map((item) => [item.state, item.case_density]),
      );
      const partnerMap = new Map(
        apiData.data.map((item) => [item.state, !!item.has_partner]),
      );
      let tempLow = 0,
        tempMedium = 0,
        tempHigh = 0,
        tempPartner = 0;
      const base = JSON.parse(JSON.stringify(updatedMarketData));
      base.data.forEach((item) => {
        const hospitalCount = hospitalCountMap.get(item.abbrev) || 0;
        const caseDensity =
          Number(Math.round(caseDensityMap.get(item.abbrev))) || 0;
        if (partnerMap.get(item.abbrev)) tempPartner += hospitalCount;
        if (caseDensity > 470) tempHigh += hospitalCount;
        else if (caseDensity > 400) tempMedium += hospitalCount;
        else tempLow += hospitalCount;
      });
      setDensityHospitalCount({
        low: tempLow,
        medium: tempMedium,
        high: tempHigh,
        partner: tempPartner,
      });
    } catch (error) {
      // Non-fatal: title count simply remains unavailable.
    }
  };

  // Repopulate density counts when viewing the table with an active legend
  // filter but the count for that bucket is missing (e.g. after remount).
  useEffect(() => {
    if (
      view === views.TABLE &&
      legendFilter !== null &&
      !densityHospitalCount?.[legendFilter]
    ) {
      fetchLegendDensityCounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, legendFilter, partnerExclusiveFlag, globalFilter?.value, quickFilter]);

  // Applying a legend filter only changes the highlight (handled live inside the
  // Hexagon) - the map data is identical regardless of the filter. So instead of
  // refetching (which flashes skeletons across the title, map and legends), just
  // recompute the per-bucket hospital counts locally for the title's count line.
  useEffect(() => {
    if (view !== views.MAP) return;
    const rows = updatedData?.data || [];
    let low = 0,
      medium = 0,
      high = 0,
      partner = 0;
    rows.forEach((item) => {
      const count = item?.value || 0;
      if (item?.performance === "high") high += count;
      else if (item?.performance === "medium") medium += count;
      else low += count;
      if (item?.isPartner) partner += count;
    });
    setDensityHospitalCount({ low, medium, high, partner });
  }, [legendFilter, updatedData, view]);

  useEffect(() => {
    // Check if filters have actually changed
    const newFilters = {
      selectedOption: localSelectedOption,
      partnerExclusiveFlag,
      sortOrder,
      globalFilter: globalFilter?.value,
      quickFilter,
      filterFlag: filterFlag, // Use effective flag to detect when filters are applied
      states, // Include selected states to trigger refetch on state changes
      search, // Refetch when the search term (URL `q`) changes / on refresh
    };

    const filtersChanged =
      JSON.stringify(newFilters) !== JSON.stringify(currentFilters);

    // When the URL still carries advanced filters but redux hasn't applied them
    // (filterFlag still false), we defer below. While deferring we must NOT
    // record currentFilters — otherwise, on reset (filterFlag flips false before
    // the URL clears), the deferred run would "consume" the change, and the
    // follow-up run after the URL clears would see no diff and never fetch the
    // all-hospitals data (leaving the table stuck on the reset skeleton).
    // Also defer while a legend filter's states are still resolving. The
    // count_by_state query that backs the legend selection is re-keyed whenever
    // quickFilter/globalFilter/partner changes, so `states` is momentarily empty
    // right after one of those changes. Fetching now would hit the all-hospitals
    // branch and load the wrong first page; wait for the legend states to arrive
    // so the state-scoped `/filter?states=...` request runs instead.
    const deferForLegend = view === views.TABLE && legendPending;
    // Guard the apply-advanced-filters race: redux `filterFlag` can flip true in
    // a render BEFORE the URL navigation carries the advanced-filter params. In
    // that transient window the fetch below would take the filterFlag branch with
    // an empty filter set and build an unscoped `all` request, which — if it
    // resolves after FilterComp's correct `filter` request — overwrites the table
    // with every hospital. Defer until the URL reflects the applied filters (or a
    // selected state). Bookmarks legitimately set filterFlag with no URL filters,
    // so they're excluded.
    const filterFlagAheadOfUrl =
      view === views.TABLE &&
      filterFlag &&
      !tableViewData?.isBookmarkData &&
      !hasUrlAdvancedFilters &&
      states.filter((s) => s !== "").length === 0;
    const willDefer =
      (view === views.TABLE && hasUrlAdvancedFilters && !filterFlag) ||
      deferForLegend ||
      filterFlagAheadOfUrl;

    // Update currentFilters state when filters change
    if (filtersChanged && !willDefer) {
      setCurrentFilters(newFilters);
    }
    // Allow sorting on filtered results, but don't trigger data fetch for other filter changes
    if (view === views.TABLE) {
      // On refresh the URL may carry advanced filters that redux hasn't applied
      // yet (filterFlag still false). Defer the all-hospitals fetch so FilterComp
      // can restore the filters and fetch the filtered data — otherwise we'd
      // flash/overwrite with all hospitals. Once filterFlag flips true this
      // guard releases and the filtered fetch proceeds normally.
      if (willDefer) {
        return;
      }
      // FilterComp already restored + fetched the filtered data on refresh
      // (filterFlag flipped true with rows present). Adopt it as-is instead of
      // refetching, which would flash the skeleton again over the same data.
      if (
        isInitialLoad &&
        filterFlag &&
        hasUrlAdvancedFilters &&
        (tableViewData?.data?.length ?? 0) > 0
      ) {
        setIsInitialLoad(false);
        return;
      }
      if (filtersChanged || isInitialLoad) {
        // Force reset when filterFlag changes to ensure we start with page 1
        const shouldForceReset = filterFlag !== tableViewData?.filterFlag;

        // If filterFlag changed, completely reset all state
        if (shouldForceReset) {
          setPage(1);
          setIsInitialLoad(false);
          setDisplayedRange({ start: 1, end: 50 });
          // Clear the Redux state to force a complete reset
          // Only preserve tableTitle if it's not "Search Results : All Hospitals"
          const shouldPreserveTitle =
            tableViewData?.tableTitle &&
            !tableViewData.tableTitle.includes(
              "Search Results : All Hospitals",
            );
          dispatch(
            setHospitalsDetails({
              view: views.TABLE,
              filterFlag: filterFlag,
              data: [],
              totalCount: 0,
              tableTitle: shouldPreserveTitle ? tableViewData?.tableTitle : "", // Only preserve if it's a real filter
            }),
          );
        }

        fetchHospitalData(shouldForceReset || filtersChanged);
      }
    }
  }, [
    localSelectedOption,
    partnerExclusiveFlag,
    sortOrder,
    globalFilter,
    quickFilter,
    filterFlag,
    states,
    specificStateData,
    isInitialLoad,
    legendFilter,
    // Release the legend defer once the count_by_state query resolves (even if it
    // resolves to zero states, where `states` itself wouldn't change).
    legendPending,
    // Re-run when advanced filters appear/clear in the URL so a reset (which
    // clears the URL after filterFlag already flipped) triggers the
    // all-hospitals re-fetch instead of getting stuck on the reset skeleton.
    hasUrlAdvancedFilters,
    // Re-run when the search term (URL `q`) changes so applying a search and a
    // refresh / shared link with `q` both fetch the search results.
    search,
  ]);

  useEffect(() => {
    if (dataRefetchTrigger) {
      // The underlying data changed, so drop the cached hospital/count results
      // before re-fetching to bypass staleTime.
      queryClient.invalidateQueries({ queryKey: ["hospitals"] });
      queryClient.invalidateQueries({ queryKey: ["count-by-state"] });
      if (view === views.MAP) {
        fetchStatesData();
      } else if (view === views.TABLE) {
        fetchHospitalData(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRefetchTrigger]);

  // Single unified data fetching function
  const fetchHospitalData = async (forceReset = false, targetPage = null) => {
    if (isLoading) return; // Prevent multiple simultaneous requests
    setIsLoading(true);

    // Reset only on explicit force or very first load. Never reset during pagination.
    const isPaginationRequest =
      typeof targetPage === "number" && targetPage > 1;
    // The bookmark endpoint returns the full set in a single (unpaginated)
    // request, so a bookmark fetch must always REPLACE the table. Without this,
    // arriving from an already-loaded table (e.g. with advanced filters applied)
    // takes the append branch and doubles every row (18 -> 36).
    const shouldReset =
      forceReset ||
      tableViewData?.isBookmarkData ||
      (!isPaginationRequest && isInitialLoad && states.length == 0);

    if (shouldReset) {
      setShowLoader(true); // Show loader for initial data fetch
      setPage(1);
      setIsInitialLoad(false);
    }

    let pageToFetch = targetPage || (shouldReset ? 1 : page);

    // Build the backend URL from the current filter context via the shared
    // builder (single source of truth; replaces the old localStorage `url` /
    // `searchURL` side channel).
    let url;
    const filteredStates = states.filter((state) => state !== "");
    const sortByValue = localSelectedOption || "ranking";
    // A text search routes to the /search endpoint only when it isn't scoped to
    // a state or advanced filters. A state search sets `q` + `state`, so it
    // falls through to the state branch below (mirrors the historical routing).
    const isTextSearch =
      !!search && filteredStates.length === 0 && !hasUrlAdvancedFilters;
    if (tableViewData?.isBookmarkData) {
      url = buildHospitalsUrlPure({
        isBookmark: true,
        partnerExclusiveFlag,
        globalFilter: globalFilter?.value || "all",
        quickFilter,
        sortBy: sortByValue,
        sortOrder,
      });
    } else if (isTextSearch) {
      // Text search is paginated like /all and /filter (50 per page).
      pageToFetch = pageToFetch === 1 && !shouldReset ? 2 : pageToFetch;
      url = buildHospitalsUrlPure({
        search,
        partnerExclusiveFlag,
        globalFilter: globalFilter?.value || "all",
        quickFilter,
        sortBy: sortByValue,
        sortOrder,
        page: pageToFetch,
        perPage: 50,
      });
    } else if (filteredStates.length > 0 && !filterFlag && !hasUrlAdvancedFilters) {
      // State selection / state search. Advanced-filter sets (which can also
      // carry a state) are owned by the filterFlag branch below.
      pageToFetch = pageToFetch === 1 && !shouldReset ? 2 : pageToFetch;
      url = buildHospitalsUrlPure({
        states: filteredStates,
        partnerExclusiveFlag,
        globalFilter: globalFilter?.value || "all",
        quickFilter,
        sortBy: sortByValue,
        sortOrder,
        page: pageToFetch,
        perPage: 50,
      });
    } else if (filterFlag) {
      // Advanced filters (optionally scoped to a state), combined with the live
      // global/partner/quick filters. The builder normalizes the URL-derived
      // advanced fields to backend keys/values.
      pageToFetch = pageToFetch === 1 && !shouldReset ? 2 : pageToFetch;
      url = buildHospitalsUrlPure({
        states: filteredStates,
        advancedFilters: appliedAdvancedFilters,
        partnerExclusiveFlag,
        globalFilter: globalFilter?.value || "all",
        quickFilter,
        sortBy: sortByValue,
        sortOrder,
        page: pageToFetch,
        perPage: 50,
      });
    } else {
      pageToFetch = pageToFetch === 1 && !shouldReset ? 2 : pageToFetch;
      url = buildHospitalsUrlPure({
        partnerExclusiveFlag,
        globalFilter: globalFilter?.value || "all",
        quickFilter,
        sortBy: sortByValue,
        sortOrder,
        page: pageToFetch,
        perPage: 50,
      });
    }

    try {
      // The built URL encodes the full filter context + page, so it doubles as
      // a stable cache key: reapplying the same filters/page is served from
      // cache instead of refetching.
      const apiData = await queryClient.fetchQuery({
        queryKey: ["hospitals", url],
        queryFn: ({ signal }) => getHospitalsByUrl(url, signal),
        staleTime: 5 * 60 * 1000,
      });

      const hospitalData = apiData.data || apiData;

      const totalCount = apiData.total_count || 0; // Capture total count from API
      const filteredData = hospitalData.filter(
        (item) => item.hosp10_name !== null,
      );

      // Calculate the starting index for serial numbering
      const startIndex = shouldReset ? 0 : tableViewData?.data?.length || 0;
      const hospitalDetailsArray = formatHospitalDetails(
        filteredData,
        startIndex,
      );

      if (shouldReset) {
        // Replace data for initial load or filter changes

        dispatch(
          setHospitalsDetails({
            view: views.TABLE,
            filterFlag: filterFlag, // Preserve filterFlag state
            data: hospitalDetailsArray,
            totalCount: totalCount,
            // The search title is derived from the URL `q` param; otherwise keep
            // the advanced-filter title (preserved only while filterFlag is on).
            tableTitle: searchTitle ?? (filterFlag ? tableViewData?.tableTitle : ""),
          }),
        );
        // Card counts for text search use search_term on /card-filter-counts
        // (HomePage); do not bridge first-page provider numbers into Redux.
        // Reset displayed range to show only first page
        setDisplayedRange({
          start: 1,
          end: Math.min(hospitalDetailsArray.length, 50),
        });
        // Reset page state
        setPage(1); // After reset, next page should be 2
        setCurrentPage(1); // Reset current page for display
      } else {
        // Append data for lazy loading, deduplicate by provider_number
        const existingData = tableViewData?.data || [];
        const newData = [...existingData, ...hospitalDetailsArray];

        dispatch(
          setHospitalsDetails({
            view: views.TABLE,
            filterFlag: filterFlag,
            data: newData,
            totalCount: totalCount,
            tableTitle: searchTitle ?? tableViewData?.tableTitle,
          }),
        );

        const pageSize = 50;
        const currentPage = Math.floor(existingData.length / pageSize) + 1;
        const currentPageStart = (currentPage - 1) * pageSize + 1;
        const currentPageEnd =
          currentPageStart + hospitalDetailsArray.length - 1;
        setDisplayedRange({ start: currentPageStart, end: currentPageEnd });
        setPage(pageToFetch + 1);
        setCurrentPage(pageToFetch + 1);
      }

    } catch (error) {
      console.error("Error fetching hospital data:", error);
    } finally {
      // Always clear the loader so the UI never stays frozen on an aborted
      // request, network error, or a 401 that is being silently refreshed.
      if (shouldReset) {
        setShowLoader(false);
        // Clear the reset-in-progress flag once the re-fetch settles, so the
        // skeleton gives way to the freshly loaded (all-hospitals) table.
        dispatch(setTableResetting(false));
      }
      setIsLoading(false);
    }
  };

  const resetToEmptyState = () => {
    setFilteredData((prevState) => ({
      ...prevState,
      hospital_name: "",
      cbsa: "",
      state: "",
      zip_code: "",
      county: "",
      CALC_STATS_BEDS_TOTAL: "",
      case_volume: "",
      facility_type: "",
      prov_control_type: "",
      coc_accredited: {
        checked: false,
        value: "",
      },
      urban_rural_flag: "",
      ownership_type: "",
      bed_count_min: "",
      bed_count_max: "",
      square_footage_min: "",
      square_footage_max: "",
      patient_discharge_min: "",
      patient_discharge_max: "",
      net_income_margin_min: "",
      net_income_margin_max: "",
      net_patient_revenue_min: "",
      net_patient_revenue_max: "",
      hospital_flags: "",
    }));
  };

  const handleProceed = () => {
    // Proceed = land on a clean empty map. Clear advanced filters + map/legend
    // selection AND switch to map view in ONE URL write. React Router v7 reads
    // the current params from a ref that only refreshes after render, so two
    // synchronous setSearchParams calls both see the same stale snapshot and the
    // last one wins — combining everything via resetFilters avoids both the
    // earlier view-clobber (2-click) bug and leftover advanced-filter params.
    resetFilters(views.MAP);
    dispatch(
      setHospitalsDetails({
        view: views.MAP,
        filterFlag: false,
        // isGraphCellClicked: false,
        data: [],
        isBookmarkData: false,
        tableTitle: "",
      }),
    );
    resetToEmptyState();
    setIsClicked({ row: null, column: null, value: false, data: null });
    // dispatch(resetSelectedState());
    // dispatch(resetSpecificStateData());
    dispatch(setGlobalSearchReset(false));
    dispatch(setIsBookmarkTable(false));
    dispatch(clearProviderNumbers());
    setShowResetModal(false);
    resetSortAndFilters();
  };

  const handleCancel = () => {
    setShowResetModal(false);
  };

  // Sync selectedOption with parent's sortFilters
  useEffect(() => {
    if (selectedOption !== "") {
      setLocalSelectedOption(selectedOption);
    }
  }, [selectedOption]);

  // Handle sorting change
  const handleOptionClick = (option) => {
    setLocalSelectedOption(option.value);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        exportDropdownRef.current &&
        !exportDropdownRef.current.contains(event.target)
      ) {
        setIsExportDropdownOpen(false);
      }

      if (
        sortModelDropdownRef.current &&
        !sortModelDropdownRef.current.contains(event.target)
      ) {
        setIsSortModelOpen(false);
      }

      setPreventToggle(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mapArea = graphAreaRef.current || parentRef?.current;
      if (mapArea) {
        const width = mapArea.offsetWidth;
        const height = mapArea.offsetHeight;

        const ratio = 1.35;
        const scaleFactor = 1.1;

        const adjustedWidth = Math.min(width, height * ratio) * scaleFactor;

        setParentWidth(adjustedWidth * 0.045);
        setLabelFontSize(adjustedWidth * 0.018);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(handleResize)
        : null;

    if (resizeObserver && graphAreaRef.current) {
      resizeObserver.observe(graphAreaRef.current);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      resizeObserver?.disconnect();
    };
  }, [view, mapAreaReady]);

  const switchToMapView = () => {
    if (view === views.MAP) return;
    if (isBookmarkTable) {
      handleProceed();
    } else {
      if (filterFlag || search) {
        // An active advanced filter set OR an active search (URL `q`) should
        // prompt the reset modal before dropping back to the map.
        setShowResetModal(true);
        // resetUrl();
      } else if (sortingLabel === "") {
        updateSearchParams({ view: views.MAP });
        resetSortAndFilters();
        dispatch(
          setHospitalsDetails({
            view: views.MAP,
            filterFlag: false,
            data: data,
          }),
        );
      } else {
        resetSortAndFilters();
        updateSearchParams({ view: views.MAP });
        dispatch(
          setHospitalsDetails({ view: views.MAP, filterFlag: false, data: [] }),
        );
      }
    }
  };

  const switchToTableView = () => {
    if (view === views.TABLE) return;
    updateSearchParams({ view: views.TABLE });
    setIsClicked({ row: null, column: null, value: false, data: null });
  };

  const resetSortAndFilters = () => {
    // Don't reset sorting if we have filtered results
    if (filterFlag) {
      return;
    }

    setLocalSelectedOption("RANKING"); // Set default sorting instead of empty string
    setSortingLabel("");
    setSortOrder("asc");
    setIsSortingDisabled(true);
    // Reset lazy loading state when filters are reset
    setPage(1);
    setIsInitialLoad(true);
    setCurrentFilters({});
  };

  const loadMoreData = async () => {
    if (isLoading) return;
    // Derive the next page from how many rows are already loaded so a load-more
    // is ALWAYS a pagination request (targetPage > 1). Passing 1 here made
    // fetchHospitalData treat it as a non-pagination call, which could trip
    // `shouldReset` (when isInitialLoad is still true, e.g. right after
    // returning from the factsheet) and reload the whole table with a skeleton
    // instead of just appending the next page.
    const loadedCount = tableViewData?.data?.length ?? 0;
    const nextPage = Math.max(2, Math.floor(loadedCount / 50) + 1);
    await fetchHospitalData(false, nextPage);
  };

  const lastElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          const hasMoreData =
            tableViewData?.totalCount > tableViewData?.data?.length;

          if (hasMoreData) {
            loadMoreData();
          }
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isLoading, states, specificStateData, tableViewData],
  );

  const toggleExportDropdown = () => {
    if (preventToggle) {
      setPreventToggle(false);
      return;
    }
    setIsExportDropdownOpen(!isExportDropdownOpen);
  };

  const toggleSortModelDropdown = () => {
    if (preventToggle) {
      setPreventToggle(false);
      return;
    }
    setIsSortModelOpen(!isSortModelOpen);
  };

  const handleSortModelOptionClick = (option) => {
    setSelectedOption(option.value);
    setSortingLabel(option.label);

    if (option.value === "hosp10_name") {
      setSortOrder("asc");
    } else {
      setSortOrder("desc");
    }

    setIsSortModelOpen(false);
  };
  const handleExport = async (option) => {
    if (!data || data.length === 0) {
      return;
    }

    try {
      setIsExportDropdownOpen(false);
      // Construct export URL from the current filter context via the shared
      // builder (forExport swaps to the /export endpoint and drops pagination).
      const filteredStates = states.filter((state) => state !== "");
      const sortByValue = localSelectedOption || "ranking";
      const isTextSearch =
        !!search && filteredStates.length === 0 && !hasUrlAdvancedFilters;
      let exportUrl;

      if (tableViewData?.isBookmarkData) {
        exportUrl = buildHospitalsUrlPure({
          isBookmark: true,
          forExport: true,
          partnerExclusiveFlag,
          globalFilter: globalFilter?.value || "all",
          quickFilter,
          sortBy: sortByValue,
          sortOrder,
        });
      } else if (isTextSearch) {
        exportUrl = buildHospitalsUrlPure({
          search,
          forExport: true,
          partnerExclusiveFlag,
          globalFilter: globalFilter?.value || "all",
          quickFilter,
          sortBy: sortByValue,
          sortOrder,
        });
      } else if (filteredStates.length > 0 && !filterFlag && !hasUrlAdvancedFilters) {
        exportUrl = buildHospitalsUrlPure({
          states: filteredStates,
          forExport: true,
          partnerExclusiveFlag,
          globalFilter: globalFilter?.value || "all",
          quickFilter,
          sortBy: sortByValue,
          sortOrder,
        });
      } else if (filterFlag) {
        exportUrl = buildHospitalsUrlPure({
          states: filteredStates,
          advancedFilters: appliedAdvancedFilters,
          forExport: true,
          partnerExclusiveFlag,
          globalFilter: globalFilter?.value || "all",
          quickFilter,
          sortBy: sortByValue,
          sortOrder,
        });
      } else {
        exportUrl = buildHospitalsUrlPure({
          forExport: true,
          partnerExclusiveFlag,
          globalFilter: globalFilter?.value || "all",
          quickFilter,
          sortBy: sortByValue,
          sortOrder,
        });
      }

      // Fetch all filtered data from the export endpoint via the mutation (no
      // caching — an export always pulls the current full dataset).
      const exportData = await exportMutation.mutateAsync(exportUrl);

      const exportFileName = tableViewData?.isBookmarkData
        ? "Bookmarked_Hospitals"
        : "Table_Data";

      if (exportData.status === 'success' && exportData.data && exportData.data.length > 0) {
        // Export the complete filtered dataset
        exportTableData(exportData.data, option.type, exportFileName);
        console.log(`Successfully exported ${exportData.data.length} records`);
      } else {
        console.error('No data available for export');
        // Fallback to current page data if export fails
        exportTableData(data, option.type, exportFileName);
      }
      
    } catch (error) {
      console.error('Export failed:', error);
      // Fallback to current page data if export fails
      exportTableData(data, option.type, tableViewData?.isBookmarkData ? "Bookmarked_Hospitals" : "Table_Data");
    }
  };

  const addMultipleToCompare = (dataArray) => {
    snack(
      "Hospital added to compare",
      "#1F1F1F",
      "#FFFFFF",
      "View",
      () => {
        if (compareHospitals.length <= 1) {
          snack(
            "Select at least two hospitals to compare!",
            "#FFC640",
            "#333333"
          );
        } else {
          toggleState("isTableVisible");
        }
      }
    );
    // Create a set of existing provider numbers to prevent duplicates
    const existingProviders = new Set(
      compareHospitals.map((h) => h.provider_number),
    );
    // Create new items, ensuring no duplicates
    const newHospitals = dataArray
      .filter((data) => !existingProviders.has(data?.provider_number))
      .map((data) => ({
        value: data["hospital name"],
        label: toTitleCase(data["hospital name"]),
        location: data["location"],
        provider_number: data?.provider_number,
      }));
    dispatch(addHospitalToCompare(newHospitals));
  };

  const rankingTotalHospitals = search
  ? tableViewData?.totalCount || tableViewData?.data?.length || 0
  : totalHospitals;
  
  return (
    <MainContainer view={view}>
      <TopSection view={view}>
        <TopSectionContent>
        {showLoader ? (
          <TextSkeleton width={14} />
        ) : Object.values(specificStateData)?.length > 0 &&
          resolvedTableTitle == "" ? (
          <TitleSection view={view}>
            <Title>
              {toTitleCase(specificStateData?.state)},{" "}
              {specificStateData?.abbreviation}
            </Title>
            <SubTitleBold>
              {tableViewData?.data?.length > 0
                ? view === views.MAP
                  ? `${tableViewData?.totalCount || tableViewData?.data?.length}`
                  : `${1}-${displayedRange.end} of ${tableViewData?.totalCount || tableViewData?.data?.length}`
                : tableViewData?.totalCount || 0}{" "}
              hospitals
            </SubTitleBold>
          </TitleSection>
        ) : legendFilter !== null && resolvedTableTitle == "" ? (
          <TitleSection view={view}>
            <Title>
              {legendFilter === "partner"
                ? "Partner ESA"
                : `${toTitleCase(legendFilter)} Density State`}
            </Title>
            <SubTitleBold>
              {view === views.TABLE ? (
                // In table view the legend subtitle must reflect the actually
                // fetched rows (which honor quick/global filters applied on top
                // of the legend), not the map's per-bucket density count —
                // densityHospitalCount is only recomputed in map view and would
                // otherwise stay stale here.
                <Span>
                  {tableViewData?.data?.length > 0
                    ? `${1}-${displayedRange.end} of ${tableViewData?.totalCount || tableViewData?.data?.length}`
                    : tableViewData?.totalCount || 0}{" "}
                  hospitals
                </Span>
              ) : densityHospitalCount[legendFilter] === 0 ? (
                <TextSkeleton width={14} />
              ) : (
                `${densityHospitalCount[legendFilter]} hospitals`
              )}
            </SubTitleBold>
          </TitleSection>
        ) : (
          <TitleSection view={view}>
            {resolvedTableTitle ? (
              resolvedTableTitle.includes("Search Results :") ? (
                <>
                  <Title>
                    {resolvedTableTitle.substring(0, "Search Results :".length)}
                    &nbsp;
                    <SubTitle style={{ display: "inline-block" }}>
                      <Span>
                        {tableViewData?.data?.length > 0
                          ? `${1}-${displayedRange.end} of ${tableViewData?.totalCount || tableViewData?.data?.length}`
                          : tableViewData?.totalCount || 0}{" "}
                        hospitals
                      </Span>
                    </SubTitle>
                  </Title>
                  <SubTitle>
                    {resolvedTableTitle?.split("Search Results :")[1]}
                  </SubTitle>
                </>
              ) : (
                // Plain title (e.g. bookmarks' "All Bookmarks"): render the
                // count on its own line below, matching the "All States"
                // layout instead of sitting inline next to the title.
                <>
                  <Title>{resolvedTableTitle}</Title>
                  <SubTitle>
                    <Span>
                      {tableViewData?.data?.length > 0
                        ? `${1}-${displayedRange.end} of ${tableViewData?.totalCount || tableViewData?.data?.length}`
                        : tableViewData?.totalCount || 0}{" "}
                      hospitals
                    </Span>
                    {sortingLabel?.trim() && (
                      <span> | Sorted by {sortingLabel}</span>
                    )}
                  </SubTitle>
                </>
              )
            ) : view === views.MAP ? (
              <>
                <TitleBlock fontSize={18} fontWeight={700}>Hospital Count by State Case Density</TitleBlock>
                <TitleBlock fontWeight={500}>Case Density /100K population</TitleBlock>

                <SubTitle>
                  {globalFilterTitle || "All Hospitals"}:{" "}
                  {(totalHospitals || 0).toLocaleString()} Hospitals
                </SubTitle>
              </>
            ) : (
              <>
                <Title>{globalFilterTitle || "All States"}</Title>

                <SubTitle>
                  <Span>
                    {tableViewData?.data?.length > 0
                      ? `${1}-${displayedRange.end} of ${tableViewData?.totalCount || tableViewData?.data?.length}`
                      : tableViewData?.totalCount || 0}{" "}
                    hospitals
                  </Span>
                  {sortingLabel?.trim() && (
                    <span> | Sorted by {sortingLabel}</span>
                  )}
                </SubTitle>
              </>
            )}
          </TitleSection>
        )}
        </TopSectionContent>
        <Wrapper>
          {view === views.TABLE && (
            <>
              {" "}
              {/* {data.length < 10 && (
                <Reset onClick={() => addMultipleToCompare(data)}>
                  Add All to Compare
                </Reset>
              )} */}
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Sorting Model",
                  position: "top",
                  offsetY: 10,
                }}
              >
                <FilterBox
                  ref={sortModelDropdownRef}
                  onClick={toggleSortModelDropdown}
                  isDisabled={
                    tableViewData?.data && tableViewData?.data?.length == 0
                  }
                  onMouseEnter={() => setIsSortModelHovered(true)}
                  onMouseLeave={() => setIsSortModelHovered(false)}
                  isHovered={isSortModelHovered}
                >
                  <AscendingDescendingSortIcon
                    style={{
                      fill: isSortModelHovered ? "#F96C50" : "#333333",
                    }}
                  />
                  <OptionsList
                    options={[]}
                    onOptionClick={handleSortModelOptionClick}
                    selectedOption={""}
                    customWidth={16.5}
                    top={3.4}
                    right={true}
                    // onPreventToggle={onPreventToggle}
                    showTitle={false}
                    showIcon={false}
                    customPadding={0.313}
                    customBorderRadius={0.625}
                    isOpen={isSortModelOpen}
                    sortOrder={""}
                    setSortOrder={() => {}}
                    isSortingDisabled={false}
                    isSelectModelOption={true}
                    showDivider={false}
                  />
                </FilterBox>
              </Info>
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Download",
                  position: "top",
                  offsetY: 10,
                }}
              >
                <FilterBox
                  ref={exportDropdownRef}
                  onClick={toggleExportDropdown}
                  isDisabled={
                    tableViewData?.data && tableViewData?.data?.length == 0
                  }
                  onMouseEnter={() => setIsExportHovered(true)}
                  onMouseLeave={() => setIsExportHovered(false)}
                  isHovered={isExportHovered}
                >
                  <DownloadDownIcon
                    style={{
                      stroke: isExportHovered ? "#F96C50" : "#333333",
                    }}
                  />
                  <OptionsList
                    options={exportOptions}
                    onOptionClick={handleExport}
                    selectedOption={exportOptions}
                    customWidth={15.75}
                    top={3.4}
                    showIcon={false}
                    right={true}
                    onPreventToggle={onPreventToggle}
                    showTitle={"Export"}
                    customPadding={0.313}
                    customBorderRadius={0.625}
                    isOpen={isExportDropdownOpen}
                  />
                </FilterBox>
              </Info>
            </>
          )}

          {(legendFilter !== null || states.length > 0) &&
            view === views.MAP && (
              <Reset
                onClick={() => {
                  // Clear the map selection (legend/state) from the URL right
                  // here — there's no navigation on this button, so resetFlag
                  // alone (which only does local/redux cleanup) wouldn't.
                  clearMapSelection();
                  setResetFlag(true);
                }}
              >
                Reset
              </Reset>
            )}
          <ViewContainer>
            <Slider>
              <SliderHoverContainer view={view} />
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Table View",
                  position: "top",
                  offsetY: 10,
                }}
              >
                <SliderContentFirst
                  onMouseEnter={() => setIsTableHovered(true)}
                  onMouseLeave={() => setIsTableHovered(false)}
                  onClick={switchToTableView}
                >
                  <ListIcon
                    fill={view === views.TABLE ? "#33333380" : "#333333"}
                    style={{
                      fill: isTableHovered ? "#F96C50" : "#333333",
                    }}
                  />
                </SliderContentFirst>
              </Info>
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Map View",
                  position: "top",
                  offsetY: 10,
                }}
              >
                <SliderContentSecond
                  onMouseEnter={() => setIsMapHovered(true)}
                  onMouseLeave={() => setIsMapHovered(false)}
                  onClick={switchToMapView}
                >
                  <MapIcon
                    fill={view === views.MAP ? "#33333380" : "#333333"}
                    style={{
                      fill: isMapHovered ? "#F96C50" : "#333333",
                    }}
                  />
                </SliderContentSecond>
              </Info>
            </Slider>
          </ViewContainer>
        </Wrapper>
      </TopSection>
      {view === views.MAP ? (
        <MainContent className="main-content">
          <GraphSection className="MainContainer">
            <HexbinMainContainer ref={parentRef}>
              <Hexagon
                graphAreaRef={setGraphAreaRef}
                data={updatedData}
                legends={true}
                size={parentWidth} // Pass the adjusted width
                handleMouseEnter={() => {}}
                // handleMouseClick={() => { }}
                handleMouseMove={() => {}}
                handleMouseLeave={() => {}}
                isClicked={isClicked}
                setIsClicked={setIsClicked}
                enableTooltip={true}
                labelFontSize={labelFontSize} // Pass the adjusted font size
                labelFontWeight={600}
                labelFontColor={"#fff"}
                tooltipLabelFont={"#0C0C0C"}
                tooltipLabelWeight={500}
                loading={showLoader}
                showSkelton={showSkelton}
                setShowSkelton={setShowSkelton}
                resetFlag={resetFlag}
                setResetFlag={setResetFlag}
                // fetchTableViewData={fetchTableViewData} // REMOVED - no longer needed
                // setFlag={setFlag}
              />
            </HexbinMainContainer>
          </GraphSection>
        </MainContent>
      ) : showLoader ||
        isTableResetting ||
        (hasUrlAdvancedFilters && !filterFlag) ||
        (isLoading && (tableViewData?.data?.length ?? 0) === 0) ? (
        // Keep the skeleton up while an initial fetch is in flight with no rows
        // yet (e.g. a refresh straight into table view) instead of briefly
        // flashing the "No Data Found" empty state before data arrives. The
        // `hasUrlAdvancedFilters && !filterFlag` case covers a refresh with
        // advanced filters in the URL, where FilterComp restores + fetches them
        // (redux filterFlag is still false during that window).
        <TableSkeleton columns={table?.columns} />
      ) : (
        <>
          <CustomTable
            data={tableViewData?.data || []}
            column={table?.columns}
            totalHospitals={rankingTotalHospitals}
            toggleState={toggleState}
            setSelectedOption={setLocalSelectedOption}
            selectedOption={localSelectedOption}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            setShowSnackbarCount={setShowBulkCount}
            setRemoveIds={setRemoveIds}
            isCompareActive={isCompareActive}
            view={view}
            lastElementRef={lastElementRef}
          />
          {/* Loading indicator for infinite scroll */}
          {view === views.TABLE && isLoading && (
            <LoadMoreContainer>
              <Loading />
            </LoadMoreContainer>
          )}

          {/* Color Scale Legend for Ranking */}
          {tableViewData?.data.some(
            (row) => row.score && row.score !== "N/A",
          ) && (
            <ColorScaleLegend>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: `${viewSizeCalculator(0.5)}`,
                }}
              >
                <span>Score Color Scale:</span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: `${viewSizeCalculator(0.25)}`,
                    flex: 1,
                  }}
                >
                  <LegendLabel color="#c34141">Low</LegendLabel>
                  <ColorGradient />
                  <LegendLabel color="#4e9e6a">High</LegendLabel>
                </div>
              </div>
            </ColorScaleLegend>
          )}
        </>
      )}

      <BackgroundOverlay isPopupVisible={showResetModal} />
      {showResetModal && (
        <ResetModal
          title={
            isGlobalSearchReset
              ? "Heads Up! Global Search May Reset"
              : "Heads Up! Filters May Reset"
          }
          description={
            isGlobalSearchReset
              ? "Global search results may not carry over while switching to map view — Check your settings!"
              : "Some filters may not carry over while switching to map view — Check your settings!"
          }
          onProceed={() => {
            dispatch(resetSelectedState());
            dispatch(resetSpecificStateData());
            // handleProceed() -> resetFilters(views.MAP) clears advanced filters
            // + map/legend selection + sets view=map in a single URL write.
            handleProceed();
            setGlobalCustomFilterOption(globalFilter);
          }}
          onCancel={handleCancel}
          showResetModal={showResetModal}
        />
      )}
    </MainContainer>
  );
};

export default LeftSection;
